import React from 'react';
import PropTypes from 'prop-types';

import {
  Flex,
  Table,
  Button,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TableActions,
  OrderableTableRow
} from '@ubisend/pulse-components';
import { PermissionFilter } from '@ubisend/pulse-auth';

const FolderTable = ({
  data,
  isLoading,
  orderProps,
  has_pending,
  onSyncFolder,
  onViewFolder,
  onDeleteFolder,
  graphFolder = false
}) => {
  if (!data || data.length === 0) {
    return (
      <Flex col center middle>
        <span>No folders available</span>
      </Flex>
    );
  }

  return (
    <Flex border xScroll>
      <Table>
        <TableHead>
          {graphFolder ? (
            <TableRow>
              <TableCell>Folder Name</TableCell>
              <TableCell>Files Available</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          ) : (
            <OrderableTableRow
              rows={[
                { label: 'Folder Name', sort: 'name' },
                { label: 'Files Synced', sort: 'files_count' },
                { label: 'Last Synced', sort: 'last_sync_at' },
                null
              ]}
              {...orderProps}
            />
          )}
        </TableHead>
        <TableBody>
          {data.map((folder) =>
            graphFolder ? (
              folder.file_count > 0 && (
                <TableRow key={folder.id}>
                  <TableCell>{folder.name}</TableCell>
                  <TableCell>{folder.file_count}</TableCell>
                  <TableCell>{folder.status}</TableCell>
                </TableRow>
              )
            ) : (
              <TableRow key={folder.id}>
                <TableCell>{folder.name}</TableCell>
                <TableCell>{folder.file_count}</TableCell>
                <TableCell>{folder.last_sync_at}</TableCell>
                <TableActions>
                  <Button
                    variant="secondary"
                    icon="eye"
                    colour="info"
                    onClick={() => onViewFolder(folder)}
                  >
                    View
                  </Button>
                  <PermissionFilter can="edit generative ai resource">
                    <Button
                      variant="secondary"
                      icon="refresh"
                      colour="primary"
                      onClick={() => onSyncFolder(folder)}
                      disabled={isLoading || has_pending}
                      isLoading={isLoading}
                    >
                      Resync
                    </Button>
                    <Button
                      variant="secondary"
                      icon="trash"
                      colour="danger"
                      onClick={() => onDeleteFolder(folder)}
                      disabled={isLoading || has_pending}
                      isLoading={isLoading}
                    >
                      Delete
                    </Button>
                  </PermissionFilter>
                </TableActions>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
    </Flex>
  );
};

FolderTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      file_count: PropTypes.number.isRequired,
      last_sync_at: PropTypes.string
    })
  ).isRequired,
  orderProps: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  has_pending: PropTypes.bool,
  onSyncFolder: PropTypes.func,
  onDeleteFolder: PropTypes.func,
  onViewFolder: PropTypes.func,
  graphFolder: PropTypes.bool
};

export default FolderTable;